/**
 * Bazowy URL Xtream API (bez końcowego slasha).
 * Dev: zawsze ścieżka względna → Vite proxy /api (unika CORS).
 */
export function getXtreamBase(): string {
  if (import.meta.env.DEV) {
    return '/api/xtream';
  }
  const configured = (import.meta.env.VITE_XTREAM_SERVER || '').trim();
  if (!configured) {
    return 'https://m3u-studio.marcincloud.org/api/xtream';
  }
  return configured.replace(/\/$/, '');
}

export const APP_TITLE = 'M3U Studio Player';
